export default "__VITE_ASSET__3a1b0799__"